<template>
  <div class="history-detail-wrap">
    <div
      :visible="visible"
      class="history-detail"
    >
      <header-back
        :title="changeHTit"
        @back="onClickBack"
      />
      <div>
        <div
          v-if="!detailLoading"
          class="spin-absolute-center"
        >
          <div
            v-if="historyDetail && historyDetail.before && Object.keys(historyDetail.before).length"
            class="detail-wrap"
          >
            <div class="before">
              <h2 class="title">
                {{ $t('message["50"]') }}
              </h2>
              <ul class="detail clearfix">
                <li
                  v-for="(one, i) in historyDetail.before"
                  ref="before"
                  :key="i"
                  :class="{ 'isdelete': one.isdelete }"
                  class="field clearfix"
                >
                  <label>{{ one.fieldname }}</label>
                  <change-value
                    :data="one"
                    :value-key="i"
                    history-type="old"
                  />
                </li>
              </ul>
            </div>
            <div class="after">
              <h2 class="title">
                {{ $t('message["47"]') }}
              </h2>
              <ul class="detail clearfix">
                <li
                  v-for="(one, i) in historyDetail.after"
                  ref="after"
                  :key="i"
                  :class="{ 'isdelete': one.isdelete }"
                  class="field clearfix"
                >
                  <label
                    v-show="!one.isdelete"
                  >{{ one.fieldname }}</label>
                  <change-value
                    :data="one"
                    :value-key="i"
                    history-type="new"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <cube-loading
          v-else
          :size="24"
        />
        <p
          v-if="!detailLoading && !(historyDetail && historyDetail.before && Object.keys(historyDetail.before).length)"
          class="tip"
        >
          {{ $t('message["1544"]') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HeaderBack from '@/components/mobile/HeaderBack.vue'
import ChangeValue from './ChangeValue'
import eventBus from '@/lib/eventBus'

export default {
  components: {
    HeaderBack,
    ChangeValue
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detailId: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      detailLoading: false
    }
  },
  computed: {
    ...mapState('inquery/detailData', ['historyDetail']),
    inquiryId () {
      return this.$route.params.inquiryId
    },
    changeHTit () {
      return this.$t('message["49"]')
    }
  },
  async created () {
    await this.getHistoryDetail(this.detailId)
    window.scrollTo(0, 0)
  },
  methods: {
    ...mapActions('inquery/detailData', ['fetchHistoryDetail']),
    onClickBack () {
      eventBus.$emit('toggleHistoryDetailModal', false)
    },
    async getHistoryDetail (id) {
      this.detailLoading = true
      const chain = await this.fetchHistoryDetail()
      chain
        .params({
          inquiryid: this.inquiryId,
          id
        })
        .onNetSuccess(res => {
          this.detailLoading = false
        })
        .fetch()
    }
  }
}
</script>

<style lang="scss" scoped>
.history-detail-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  overflow: scroll;

  .tip {
    padding: 10px;
  }
}
.back-list {
  padding: 12px;
}
.detail-wrap {
  .title {
    margin: 0;
    padding: 12px;
    font-weight: bold;
    background-color: #F5F5F5;
  }
  .detail {
    .field {
      display: flex;
      padding: 12px 0;
      border-bottom: solid 1px $gray4;
      &.isdelete {
        border: none;
      }
    }
    label {
      width: 84px;
      padding-left: 12px;
      color: #888;
      line-height: 1.2;
      font-size: 16px;;
    }
  }
}
</style>
